export class SecurityGroup {
  id: any;
  name!: string;
  description = '';
  numberOfEmployees!: number;
  responsibleTypeId!: number;
  department!: string;
  isDeputy!: boolean;
  checkDuplicateName!: boolean;
  canDelete!: boolean;
}

export class SecurityGroupPagingModel {
  totalCount!: number;
  chemicalSecGroup!: SecurityGroup[];
}